
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useAvatarBundleEdit } from '@/modules/avatar/bundle/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { AvatarBundleOptions } from '@/modules/avatar/bundle/model/mixins';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BUNDLE.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, fetch, actions } = useAvatarBundleEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, AvatarBundleOptions, ROUTE_NAME_AVATAR };
    }
});
